import axios, {AxiosRequestConfig, AxiosResponse} from 'axios';
import IAjax from './types';
// import { store } from 'src/store';
import {stringify} from "../common/utilTools";
import useRedux from "../hooks/useRedux";
import { useMessage } from "../hooks/useMessage";

export const service_api = "https://optionvault.dvol.finance/"
export interface reqConfig extends AxiosRequestConfig{
  postType?: string,
  headers?: any
}
// axios.defaults.baseURL = service_api;
//=>Set the request header
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.timeout = 30*1000;
interface myConfig extends AxiosRequestConfig {
    userConfig?:any
}
// =>Setting up request interceptors
/*axios.interceptors.request.use((config:myConfig) => {
        if (config.headers && config.headers.common) {
            let token = sessionStorage.getItem('token') || "";
            if (token) {
                config.headers.common['Authorization'] = token;
            }
            let language = $router.query.lang || store.getState().lang;
            config.headers.common['Accept-Language'] = language.replace("_", "-");
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);*/
// =>Setting up response interceptors
/*axios.interceptors.response.use((response:AxiosResponse<IAjax>):Promise<any> => {
        if (response.status === 200) {
            if (response.data) {
                if (response.data.error) {
                    if (!response.config.headers.disabledWarn) {
                        showMessage(response.data.msg);
                    }
                    /!*token expiration exit*!/
                    if (response.data.code === 4003) {
                        PubSub.publish(wallet_logout);
                    }
                    return Promise.reject(response.data);
                } else {
                    return Promise.resolve(response.data);
                }
            } else {
                return Promise.reject("server busy!")
            }
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        showMessage(error.toString());
        return Promise.reject(error);
    }
);*/

/*export  {
    axios
}*/


export function useAxios(baseURL = service_api) {
   const {storeData} = useRedux();
   const { showMessage } = useMessage();
   const instance = axios.create({
      baseURL: baseURL,
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
      },
      timeout: 30 * 1000
   });

   instance.interceptors.request.use((config: any) => {
           if (config.headers && config.headers.common) {
               // let token = sessionStorage.getItem('token') || "";
               let token = "";
               if (token) {
                   config.headers.common['Authorization'] = token;
               }
               // let language = $router.query.lang || store.getState().lang;
               let language = "";
               config.headers.common['Accept-Language'] = language.replace("_", "-");
           }

           return config;
       },
       error => {
           return Promise.reject(error);
       }
   );

   instance.interceptors.response.use((response:AxiosResponse<IAjax>):Promise<any> => {
           if (response.status === 200) {
               if (response.data) {
                   if (response.data.error) {
                       if (!response.config.headers.disabledWarn) {
                         showMessage(response.data.msg);
                       }
                       /*token expiration exit*/
                       if (response.data.code === 4003) {
                           // PubSub.publish(wallet_logout);
                       }
                       return Promise.reject(response.data);
                   } else {
                       return Promise.resolve(response.data);
                   }
               } else {
                   return Promise.reject("server busy!")
               }
           } else {
               return Promise.reject(response);
           }
       },
       error => {
          showMessage(error.toString());
          return Promise.reject(error);
       }
   );

    function fetchGet<R extends Object>(url:string, data?:object, config?:object):Promise<IAjax<R>> {
        let reqURL = data ? `${url}?${stringify(data)}` : url;
        return instance.get(reqURL, config);
    }

    function fetchPost<R extends Object>(url:string, data = {}, config:reqConfig = {}):Promise<IAjax<R>> {
        if (data instanceof FormData) {
            return instance.post(url, data, config);
        } else {
            if (!config.headers) {
                config.headers = {};
            }
            if (!config.headers['Content-Type']) {
                config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            }
            return instance.post(url, JSON.stringify(data), config);
        }
    }

   return { instance, fetchGet, fetchPost }
}
